export default {
  apiVersion: 2,
  development: {
    accessToken: '0e860fd7fae8551765e267d167552c6b',
    url: 'http://teogkaffi.th/_/moya/pilot/api',
  },
  production: {
    accessToken: '0e860fd7fae8551765e267d167552c6b',
    url: 'https://www.teogkaffi.is/_/moya/pilot/api',
  },
};
